module.exports = "/images/transferred.png?94829ab551e94fcdb85a9c698ad0cfe0";